import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/hooks/useSeo";
import { api } from "@/lib/api";
import { shareWhatsApp } from "@/lib/whatsapp";
import { ArrowLeft, CheckCircle2, MessageCircle, Loader2 } from "lucide-react";

export default function TipDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { t, lang } = useApp();
  const tp = t.tips;
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/articles/${id}`).then((r) => setA(r.data)).catch(() => nav("/tips")); }, [id, nav]);
  useSeo({ title: a?.[`title_${lang}`], description: a?.[`excerpt_${lang}`], image: a?.image, type: "article" });
  if (!a) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-tigris" size={40} /></div>;

  return (
    <article className="bg-sand min-h-screen" data-testid="tip-detail">
      <div className="relative h-[320px] sm:h-[420px]">
        <img src={a.image} alt={a[`title_${lang}`]} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-tigris-dark/95 via-tigris-dark/40 to-transparent" />
        <div className="absolute bottom-0 inset-x-0 p-6 sm:p-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/tips" data-testid="back-to-tips" className="inline-flex items-center gap-1.5 text-white/80 text-sm mb-4 hover:text-white"><ArrowLeft size={16} className="ltr:rotate-180" /> {tp.title}</Link>
            <span className="block text-gold text-xs font-bold mb-2">{tp.cats[a.category]}</span>
            <h1 className="text-white text-3xl sm:text-4xl font-bold font-display leading-tight" data-testid="tip-title">{a[`title_${lang}`]}</h1>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <p className="text-lg text-slate-600 leading-relaxed mb-8">{a[`excerpt_${lang}`]}</p>
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-6 sm:p-8 space-y-4">
          {(a[`body_${lang}`] || []).map((line, i) => (
            <div key={i} className="flex items-start gap-3">
              <CheckCircle2 size={20} className="text-gold shrink-0 mt-0.5" />
              <p className="text-slate-700 leading-relaxed">{line}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <button data-testid="share-tip-wa" onClick={() => shareWhatsApp(`${a[`title_${lang}`]}\n${a[`excerpt_${lang}`]}\n${window.location.href}`)}
            className="btn-wa inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm"><MessageCircle size={18} /> {t.common.shareWhatsapp}</button>
          <Link to={a.category === "destinations" ? "/packages" : "/services"} data-testid="tip-cta" className="btn-gold inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm">
            {a.category === "destinations" ? t.nav.groups : t.nav.services}
          </Link>
        </div>
      </div>
    </article>
  );
}
